import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import CardSummary from '../AdyenPaymentCardSummary.js';

const CreditcardSummary = (props)=>/*#__PURE__*/ React.createElement(CardSummary, swcHelpers.extends({}, props))
;
var AdyenCreditcardSummary = CreditcardSummary;

export { AdyenCreditcardSummary as default };
//# sourceMappingURL=CreditcardSummary.js.map
